function PlayButton({ width = 40, height = 40 }) {
    return (
        <svg width={width} height={height} viewBox="0 0 24 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.796509 3.80117C0.356624 3.80117 2.70009e-05 4.15777 2.70009e-05 4.59766C2.70009e-05 5.03754 0.356624 5.39414 0.796509 5.39414V4.59766V3.80117ZM23.8945 4.59766L15.9297 -0.000833511V9.19615L23.8945 4.59766ZM0.796509 4.59766V5.39414H16.7261V4.59766V3.80117H0.796509V4.59766Z" fill="white" />
        </svg>
    )
}

export default PlayButton;
